<template>
  <footer v-if="isMdAndUp" class="relative hidden bg-secondary md:block">
    <UiContainer class="grid grid-cols-3 py-5">
      <div class="flex flex-col gap-4">
        <InticketsLogo width="118" />
        <UiButtonLink
          tag="a"
          href="https://gazprombonus.ru/catalog?promotion=2659&productType=PRODUCT_TYPE_OPTION&productId=937&utm_source=partner&utm_medium=partner&utm_campaign=intickets&utm_content=website&utm_term=logo"
        >
          <GazpromBonusLogoBlue width="118" height="40" />
        </UiButtonLink>
      </div>
      <nav class="col-span-2 flex justify-between">
        <ul class="flex flex-col gap-1">
          <UiButtonLink v-for="link in FAQLinks.slice(0, 3)" :key="link.title" tag="li">
            <Component
              :is="link.external ? 'a' : AppRouterLink"
              :to="link.to"
              :href="link.to"
              class="text-base font-normal text-text-main"
            >
              <p>{{ link.title }}</p>
            </Component>
          </UiButtonLink>
        </ul>
        <ul class="flex flex-col gap-1">
          <UiButtonLink v-for="link in FAQLinks.slice(3)" :key="link.title" tag="li">
            <Component
              :is="link.external ? 'a' : AppRouterLink"
              :to="link.to"
              :href="link.to"
              class="text-base font-normal text-text-main"
            >
              <p>{{ link.title }}</p>
            </Component>
          </UiButtonLink>
        </ul>
      </nav>
    </UiContainer>
  </footer>
</template>

<script setup lang="ts">
import { FAQLinks } from '@/5_entities/FAQ'
import { useBreakpoint } from '@/6_shared/lib'
import {
  AppRouterLink,
  InticketsLogo,
  UiButtonLink,
  UiContainer,
  GazpromBonusLogoBlue
} from '@/6_shared/ui'

const {
  md: [isMdAndUp]
} = useBreakpoint()
</script>
